// Curated editorial articles displayed on visa country pages.
// Keyed by country id (see backend/seed_visas.py). Rendered by VisaFeaturedArticle.

export const VISA_FEATURED_ARTICLES = {
  india: [
    {
      id: "india-evisa-five-year",
      title: "Applying for an India e-Visa? Think Five Years!",
      dek: "If you're eligible and expect to visit India more than once, the 5-Year e-Tourist Visa can save years of repeated applications.",
      image: {
        src: "https://customer-assets-rejwkqb3.emergentagent.net/job_flight-network-1/artifacts/3cgpw7xi_india-tourist-visa-infographic.jpg",
        alt: "Going to India? Don't make this visa mistake — infographic comparing 30-day, 1-year and 5-year India e-Tourist Visas.",
      },
      tags: ["e-Visa", "Tourist", "Long-term travel"],
      body: [
        {
          type: "p",
          text: "US citizens pay $25 for a 30-day India e-Visa, $40 for a 1-year, and $80 for a 5-year e-Tourist Visa — plus a 2.5% bank processing surcharge on each payment. These fees are set by the Indian government and paid in US dollars through the official portal at indianvisaonline.gov.in.",
        },
        {
          type: "h3",
          text: "Why apply once for five years?",
        },
        {
          type: "p",
          text: "Anyone who has completed the India e-Visa application knows it takes some effort. You may need to provide:",
        },
        {
          type: "list",
          items: [
            "Passport and personal information",
            "Information about your parents and family",
            "Details of previous Indian visas",
            "Dates of previous visits to India",
            "Places you visited or stayed",
            "Information from previous passports or visas",
          ],
        },
        {
          type: "p",
          text: "Some of this information may not be immediately available — especially if you have replaced your passport, misplaced an old visa, or simply don't remember the details of a trip from years ago. So why go through the same process again and again?",
        },
        {
          type: "h3",
          text: "Benefits of the 5-Year e-Tourist Visa",
        },
        {
          type: "checks",
          items: [
            "Valid for five years from the date the ETA is granted",
            "Multiple entries",
            "No need to submit a new tourist e-Visa application for every trip during its validity",
            "Useful for visiting family and friends, vacations, weddings, reunions and other eligible tourist visits",
            "Less paperwork and fewer last-minute visa worries",
          ],
        },
        {
          type: "p",
          text: "The Government of India also offers 30-day and 1-year e-Tourist Visas, so choose according to your travel needs.",
        },
        {
          type: "callout",
          tone: "tip",
          text: "My suggestion: If India is a place you are likely to visit again, look at the 5-year option before automatically choosing the shortest visa. Spend a little more today and potentially save yourself years of repeated applications.",
        },
        {
          type: "callout",
          tone: "warn",
          text: "Important: Visa fees and eligibility vary according to nationality, and rules can change. Always check the current requirements and fee for your passport before applying. Apply only through the official Government of India e-Visa website — not through an unofficial visa service charging unnecessary processing fees.",
        },
        {
          type: "p",
          text: "Visit India. Enjoy India. And make your next trip easier.",
        },
      ],
      official_link: {
        label: "Official Government of India e-Visa portal",
        url: "https://indianvisaonline.gov.in/evisa",
        note: "This is the only official e-Visa website for India. No intermediary or travel agent is required.",
      },
      hashtags: [
        "India",
        "IndiaTravel",
        "IndiaVisa",
        "eVisa",
        "TravelIndia",
        "VisitIndia",
        "IndianDiaspora",
        "TravelTips",
      ],
      published_at: "2026-02-01",
    },
  ],
};

export function getFeaturedArticles(countryId) {
  return VISA_FEATURED_ARTICLES[countryId] || [];
}
